import React, {useEffect, useState,} from "react";
// リダイレクト(認証期間切れの場合にリダイレクトするため)
import {useHistory} from "react-router-dom";

import {
  apollo_account_platform_menu_all_path,
} from "../../atom/Apollo_links";

import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Grid from "@material-ui/core/Grid";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

import {useForm} from "react-hook-form";
import {useParams} from "react-router-dom";

import {
  AccountPlatform,
  MenuSelectInfo,
} from "../../organism/ACCOUNT/AccountModel";
import {
  MenuCampaignMaster,
} from "../../organism/MASTER/Apollo_MasterModel";

import {ApolloMessage} from "../../atom/Apollo_Mesasge";
import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";

// エラーメッセージ
const ERROR_MESSGAE = [
  "広告主アカウントメニューの取得に失敗しました",
  "広告主アカウントメニュー情報が見つかりませんでした",
];

export type PropsCheckAccountMenu = {
  checked: MenuSelectInfo[]                // 選択値
  setChecked: any                          // 選択値セット関数
  menuCampaignMaster: MenuCampaignMaster[] // メニューキャンペーンマスタ
  isDisabled: boolean                      // 不活化
  required: boolean                        // 必須
  getStatus: boolean                       // 再読み込みフラグ (呼び出し元とデータの同期をとるため)
}

interface CheckAccountMenuProps {
  propsCheck: PropsCheckAccountMenu
};

// メニュー選択チェックボックス表示
export default function ApolloCheckAccountMenu(props: CheckAccountMenuProps) {

  const {accountid} = useParams<{accountid: string}>();

  const {data, setmsg} = React.useContext(ApolloMessage);
  const {errors, setError, clearErrors} = useForm();
  const [redisp, setRedisp] = useState(false);
  // リダイレクト(認証期間切れの場合にリダイレクトするため)
  const history = useHistory();

  const {
    checked,
    setChecked,
    isDisabled,
    getStatus,
  } = props.propsCheck;

  // すべてのチェックボックス状態を設定する
  const isAllChecked = () => {
    let flag = true;
    checked.map((_, index) => {
      flag = flag && checked[index].checked;
      return null;
    })
    return flag;
  }

  // 一部が選択されている状態を設定する
  const isIndeterminateChecked = () => {
    let flag = false;
    checked.map((_, index) => {
      flag = flag || checked[index].checked;
      return null;
    })
    return isAllChecked() ? false : flag;
  }
  // メニュー「すべて」選択
  const handleChangeAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    let flag = false;
    checked.map((_, index) => {
      flag = flag || checked[index].checked; 
      return null;
    })
    checked.map((_, index) => {
      checked[index].checked = !flag; 
      return null;
    })
    setChecked(checked);
    (event.target.checked)
    ? clearErrors("menu")
    : setError("menu", {type: "manual",message: "必須選択項目です。"});
  }

  // メニュー選択状況チェック
  const isChecked = () => {
    let flag = false;
    checked.map((data, _) => {
      flag = flag || data.checked; 
      return null;
    })
    return flag;
  }

  // メニュー選択ハンドラ
  const handleChanges = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
    checked[index].checked = event.target.checked;
    setChecked(checked);
    isChecked()
    ? clearErrors("menu")
    : setError("menu", {type: "manual",message: "必須選択項目です。"});
  }

  // チェックボックスを選択済みにする
  const setAccoutPlatform = (accoutPlatform: AccountPlatform[]) => {
    checked.map((menu: MenuSelectInfo, index2: number) => {
      accoutPlatform.map((accountMmenu: AccountPlatform, index1: number) => {
        // 0:未作成、1: 利用可, 2: 未利用 ,3: 利用不可 ,4:作成時エラー,5:更新時エラー
        if (accountMmenu.menuId === menu.menuId && accountMmenu.campaignKindId === menu.campaignKindId) {
          checked[index2].checked = (accountMmenu.useStatus === 2 || accountMmenu.useStatus === 3) ? false : true;
        }
        return null;
      });
      return null;
    });
    setChecked(checked);
    setRedisp(!redisp);
  }

    // API 取得
  useEffect(() => {
    // 更新の場合は、広告主アカウントメニューを取得する
    if (accountid !== "0") {
      // 広告主アカウントメニュー取得(キャンペーン種別で縛らない)
      const urlPlatform =  apollo_account_platform_menu_all_path + "/" + accountid;
      ApolloAxios.get(urlPlatform).then(response => {
        if (response.data.resultCode === 0) {
          if (response.data.result.length === 0) {
            setmsg({
              type: "setMessage",
              payload: {
                ...data,
                open: true,
                type: "error",
                message: ERROR_MESSGAE[1],
              }
            });
          }
          // チェックボックスをチェック済みに設定
          setAccoutPlatform(response.data.result);
        } else {
          console.log(response.data.message);
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: ERROR_MESSGAE[0],
            }
          });
        }
      }).catch(err => {
        // 認証期間切れ判定とエラーメッセージ表示
        if (!ApolloExpired(err, ERROR_MESSGAE[0], data, setmsg, history)) {
          // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
        }
      });
    }
  }, [getStatus]);

  return (
    <Grid item xs={12}>
      <Grid item xs={12}>
        <FormControl error={errors.menu ? true : false}>
          <FormHelperText id="menu">メニュー *</FormHelperText>
          <FormHelperText>{errors.menu && errors.menu.message}</FormHelperText>
        </FormControl>
      </Grid>
      <Grid item xs={12} container spacing={1}>
        <Grid item xs={12} md={3}>
          <FormControlLabel
            label="すべて"
            control={
              <Checkbox
                name="menu"
                checked={isAllChecked()}
                indeterminate={isIndeterminateChecked()}
                onChange={handleChangeAll}
                color="primary"
                disabled={isDisabled}
              />
            }
          />
        </Grid>

        {/* メニュー 個別 */}
        {checked?.map((data, index) => (
          data.campaignKindId === 0 &&
            <Grid item xs={12} md={3}>
              <FormControlLabel
                label={data.menuName}
                key={data.menuName ? "Loaded" : "Loading"}
                control={
                  <Checkbox
                    checked={data.checked}
                    onChange={(e) => handleChanges(e, index)}
                    color="primary"
                    disabled={isDisabled}
                  />
                }
              />
            </Grid>
          )
        )}
        {checked?.map((data, index) => (
          data.campaignKindId !== 0 &&
            <Grid item xs={12}>
              <Grid item xs={12} container spacing={1}>
                <Grid item xs={12} md={10}>
                </Grid>
                <Grid item xs={12} md={2}>
                  <FormControlLabel
                    label={data.campaignKindName}
                    key={data.menuName ? "Loaded" : "Loading"}
                    control={
                      <Checkbox
                      checked={data.checked}
                      onChange={(e) => handleChanges(e, index)}
                      color="primary" 
                      disabled={isDisabled}
                      />
                    }
                  />
                </Grid>
              </Grid>
            </Grid>
          )
        )}
      </Grid>
    </Grid>
  )
}
